import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/api";
import toast from "react-hot-toast";
import ProjectForm from "./ProjectForm";

const AdminEditProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadProject = async () => {
    try {
      const res = await api.get("/projects?limit=100");
      const found = res.data.items?.find((item) => item.id === id);

      if (!found) {
        toast.error("Project not found");
        navigate("/admin/projects");
        return;
      }

      setProject(found);
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to load project");
    }
  };

  useEffect(() => {
    loadProject();
  }, [id]);

  const updateProject = async (payload) => {
    try {
      setLoading(true);
      await api.put(`/projects/${id}`, payload);
      toast.success("Project updated successfully");
      navigate("/admin/projects");
    } catch (err) {
      toast.error(err.cleanMessage || "Failed to update project");
    } finally {
      setLoading(false);
    }
  };

  if (!project) return <p>Loading project...</p>;

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-black text-[#0b6b1d]">
          Edit Project
        </h1>
        <p className="text-slate-500 mt-1">
          Update project details, image, category and content.
        </p>
      </div>

      <ProjectForm
        initialData={project}
        onSubmit={updateProject}
        loading={loading}
      />
    </div>
  );
};

export default AdminEditProject;